import { alpha, Components, Theme, toggleButtonGroupClasses } from '@mui/material'

export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      flex: 1,
      padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
      color: theme.palette.secondary.main,
      [`&.${toggleButtonGroupClasses.firstButton} , &.${toggleButtonGroupClasses.middleButton}, &.${toggleButtonGroupClasses.lastButton}`]:
        {
          border: 'none',
          borderTopRightRadius: theme.shape.borderRadius,
          borderBottomRightRadius: theme.shape.borderRadius,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderBottomLeftRadius: theme.shape.borderRadius,
        },
      [`&.${toggleButtonGroupClasses.selected}`]: {
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.action.selected,
      },
    }),
  },
}

export const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(0.5),
      border: `1px solid ${alpha(theme.palette.secondary.main, 0.5)}`,
      borderRadius: theme.shape.borderRadius,
      gap: theme.spacing(0.5),
    }),
  },
}
